import React, { useEffect, useMemo } from 'react';
import { TextInputProps } from '../../interfaces/TextInputProps';
import { Form, Label } from 'semantic-ui-react';
import './POSCurrencyInput.less';

export interface Props extends TextInputProps {
  prefix: string;
  decimalPlaces: number;
  onCurrencyValueChange: (value: string | undefined) => void;
}

export const POSCurrencyInput = (props: Props) => {
  const [value, setValue] = React.useState<string>('');

  const validNumber = new RegExp(/^\d*\.?\d*$/);
  const setValidValue = (inputValue: string) => {
    if (inputValue == '' || validNumber.test(inputValue)) {
      const dotIndex = inputValue.indexOf('.');
      if (
        dotIndex >= 0 &&
        inputValue.length >= dotIndex + props.decimalPlaces
      ) {
        inputValue = inputValue.substr(0, dotIndex + props.decimalPlaces + 1);
        setValue(inputValue);
      } else {
        setValue(inputValue);
      }
      props.onCurrencyValueChange && props.onCurrencyValueChange(inputValue);
    }
  };

  const handleChange = (e: any) => {
    setValidValue(e.target.value);
  };

  useEffect(() => {
    setValidValue(props.value?.toString() ?? '');
    /* eslint-disable-next-line */
  }, [props.value]);

  const prefixClassName = useMemo(() => {
    let className = '';
    if (props.prefix && props.prefix.length >= 5) {
      className = 'input-padding-five-chars';
    } else if (props.prefix.length >= 3) {
      className = 'input-padding';
    }
    return className;
  }, [props.prefix]);

  return (
    <Form.Input
      input={
        <div className="input-content">
          <Label className="prefix">{props.prefix}</Label>
          <input
            className={prefixClassName}
            value={value}
            onChange={handleChange}
            maxLength={props.maxLength}
            placeholder={props.placeholder}
            autoFocus={props.autoFocus ? props.autoFocus : false}
            id={props.id}
          />
        </div>
      }
      disabled={props.disabled ? props.disabled : false}
      required={props.required ? props.required : false}
      label={props.label ? props.label : ''}
      error={props.error}
      type="text"
      className="pos-currency-input"
    />
  );
};

POSCurrencyInput.defaultProps = {
  prefix: '$',
  decimalPlaces: 2,
};
